module.exports = __webpack_public_path__ + "img/img03.f9660633.png";